<div class="forgetPasswordContainer">
    <div class="card">
        <div class="forgetPasswordHeader">
            <div class="card-body">
                <div class="forgotPasswordHeader">
                    <h2>{{ 'register.forgotPass' | translate }}</h2>
                    <p>{{ 'register.forgotPass-desc' | translate }}</p> 
                </div>
                <form [formGroup]="forgetPasswordForm">
                    <div class="form-group col">
                        <label>{{ 'register.email2' | translate }}</label>
                        <input type="email" formControlName="email" class="form-control" placeholder="{{ 'register.email2' | translate }}" [readonly]="validated"> 
                        <div *ngIf="forgetPasswordForm.controls['email'].invalid && forgetPasswordForm.controls['email'].touched" class="invalid-feedback">
                            <div *ngIf="forgetPasswordForm.controls['email'].errors.required">{{ 'register.email_req' | translate }}</div>
                            <div *ngIf="forgetPasswordForm.controls['email'].errors.email">{{ 'register.email_valid' | translate }}</div>
                        </div>
                        <div *ngIf="apiError" class="invalid-feedback">{{ 'register.email_api_err' | translate }}</div>
                        <!-- <div class="success-reset" *ngIf="validated"> -->
                            <p class="success-reset" *ngIf="validated">{{ 'register.forgot_success' | translate }}</p>
                        <!-- </div> -->
                    </div>
                    <div class="form-group col">
                        <button type="submit" class="btn btn-primary btn-block" (click)="onSubmit()" [disabled]="disabled" [class.spinner]="loading">{{ 'register.sendReset' | translate }}</button>
                        <div *ngIf="retry" class="invalid-feedback">Next request can be sent on {{counter}}s</div>
                    </div>
                </form>
            </div>
        </div>
    </div>
</div>